/**
 *
 * MeasurementDetailsSegmentsTable
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
import { Table, Modal } from "antd"
import { filter, debounce, uniq, has, flatMap } from "lodash"
import alertSvg from "images/alert.svg"
import { columns } from "./columns"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class MeasurementDetailsSegmentsTable extends React.Component {
  state = {
    rowSelected: {},
    expandedRowKeys: [],
    modalResendSurvey: false,
    modalDeleteDivOrColl: false,
    resendSurveyTo: {},
    filteredInfo: null,
    sortedInfo: null,
  }

  componentDidUpdate(newProps) {
    const { checkIncludeSubdivisions } = this.props
    if (newProps.checkIncludeSubdivisions !== checkIncludeSubdivisions) {
      this.clearAll()
    }
  }

  expandedRows = () => {
    const { isSearching, data } = this.props
    const { expandedRowKeys } = this.state

    if (isSearching) {
      const response = flatMap(data, (item) => item.id_segment)
      return uniq(response)
    }

    return uniq(expandedRowKeys)
  }

  setStateFrom = (values) => {
    this.setState(values)
  }

  debounceRowSelected = debounce((record) => {
    this.setState({ rowSelected: record })
  }, 50)

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    })
  }

  clearAll = () => {
    this.setState({
      filteredInfo: null,
      sortedInfo: null,
    })
  }

  expandedRowRender = (record) => {
    const columns = [
      { title: "Colaborador", dataIndex: "full_name", key: "full_name" },
      { title: "Correo", dataIndex: "email", key: "email" },
    ]

    return (
      <Table
        bordered
        size="small"
        columns={columns}
        dataSource={record.children}
        pagination={false}
      />
    )
  }

  render() {
    const {
      idStatus,
      loading,
      deleteCollDivWatcher,
      resendCollDivWatcher,
      checkIncludeSubdivisions,
    } = this.props
    const {
      expandedRowKeys,
      rowSelected,
      modalResendSurvey,
      resendSurveyTo,
      modalDeleteDivOrColl,
      sortedInfo,
      filteredInfo,
    } = this.state

    return (
      <Fragment>
        <Table
          bordered
          size="small"
          className={`measurement-details-segments-table${
            idStatus == 5 ? "" : " add-style-three-column-segments"
          }`}
          // expandIconColumnIndex={2}
          rowKey={(record) => {
            if (record.id_employee) return record.id_employee
            return record.id_segment
          }}
          // expandable={{ expandedRowRender: this.expandedRowRender }}
          expandedRowKeys={this.expandedRows()}
          onExpand={(expanded, record) => {
            if (expanded) {
              this.setState({
                expandedRowKeys: uniq([...expandedRowKeys, record.id_segment]),
              })
            } else {
              this.setState({
                expandedRowKeys: filter(
                  uniq(expandedRowKeys),
                  (item) => item !== record.id_segment
                ),
              })
            }
          }}
          onRow={(record) => {
            return {
              onMouseEnter: () => this.debounceRowSelected(record),
              onMouseLeave: () => this.debounceRowSelected({}),
            }
          }}
          loading={loading}
          columns={columns(
            idStatus,
            this.props.onlyEnps,
            rowSelected,
            this.setStateFrom,
            checkIncludeSubdivisions,
            sortedInfo,
            filteredInfo
          )}
          dataSource={this.props.data}
          pagination={{
            pageSizeOptions: ["15", "25", "50", "100"],
            showSizeChanger: true,
            size: "default",
            defaultPageSize: 15,
          }}
          onChange={this.handleChange}
        />
        <Modal
          visible={modalResendSurvey}
          okText="Reenviar"
          cancelText="Cancelar"
          bodyStyle={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
          afterClose={() => this.setState({ resendSurveyTo: {} })}
          onOk={() => {
            const {
              match: { params },
            } = this.props
            const paramsInfo = {
              idMeasure: params.id,
              idEmployee: resendSurveyTo.id_employee,
              idDivision: resendSurveyTo.id_segment,
            }

            resendCollDivWatcher(paramsInfo)
            this.setState({ modalResendSurvey: false })
          }}
          onCancel={() => {
            this.setState({ modalResendSurvey: false })
          }}
          width={520}>
          <img src={alertSvg} className="alertIcon" style={{ height:30 }} />
          <span style={{ marginTop: 16, fontSize: 14 }}>
            ¿Estás seguro de que deseas reenviar la encuesta a:{" "}
            <strong>{resendSurveyTo.full_name || resendSurveyTo.name}</strong>?
          </span>
          {!resendSurveyTo.id_employee && (
            <p style={{ fontSize: 13, marginTop: 8, marginBottom: 0 }}>
              Esta será reenviada <strong>únicamente</strong> a aquellos
              colaboradores que aún no la han contestado.
            </p>
          )}
        </Modal>

        <Modal
          visible={modalDeleteDivOrColl}
          okText="Eliminar"
          cancelText="Cancelar"
          bodyStyle={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
          afterClose={() => this.setState({ resendSurveyTo: {} })}
          onOk={() => {
            const {
              match: { params },
            } = this.props
            const paramsInfo = {
              idMeasure: params.id,
              idEmployee: resendSurveyTo.id_employee,
              idDivision: resendSurveyTo.id_division,
            }

            deleteCollDivWatcher(paramsInfo)
            this.setState({ modalDeleteDivOrColl: false })
          }}
          onCancel={() => {
            this.setState({ modalDeleteDivOrColl: false })
          }}
          width={520}>
          <img src={alertSvg} style={{ maxHeight: "30px" }} />
          <span style={{ marginTop: 16, fontSize: 14 }}>
            {`¿Estás seguro de que deseas eliminar
               ${has(resendSurveyTo, "document") ? "a:" : "la división:"}
             `}
            <strong>{resendSurveyTo.full_name || resendSurveyTo.name}</strong>?
          </span>
          <p style={{ fontSize: 13, marginTop: 8, marginBottom: 0 }}>
            {`La acción no será revertible y se perderán
               ${
                 has(resendSurveyTo, "document")
                   ? "sus respuestas, si es que las hubieran."
                   : "todas las respuestas de los colaboradores dentro, si es que las hubieran."
               }
             `}
          </p>
        </Modal>
      </Fragment>
    )
  }
}

MeasurementDetailsSegmentsTable.propTypes = {}

export default MeasurementDetailsSegmentsTable
